import { useEffect, useState } from "react";
import { subscribeChatMeta } from "../../chat/chatService";

export default function UserChatBadge({ uid, onOpen }) {
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!uid) return;
    const unsub = subscribeChatMeta(uid, (meta) => {
      setUnread(meta?.unreadForUser || 0);
    });
    return () => unsub && unsub();
  }, [uid]);

  if (!uid) return null;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      {unread > 0 && (
        <span
          style={{
            background: "#dc2626",
            color: "#fff",
            borderRadius: 999,
            padding: "2px 8px",
            fontSize: 12,
          }}
        >
          Нових: {unread}
        </span>
      )}
      <button
        type="button"
        onClick={onOpen}
        style={{
          background: "#3e51c1",
          color: "#fff",
          border: "1px solid #3e51c1",
          padding: "6px 10px",
          cursor: "pointer",
        }}
      >
        Відкрити чат
      </button>
    </div>
  );
}
